import React, { useContext } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { StaticContext } from '@sm/webassets';
import LinkBlocked from './pages/LinkBlocked';
import Pricing from './pages/Pricing';
import AppsDirectory from './pages/AppsDirectory';
import MRXSolutions from './pages/MRX/MRXSolutions';
import CreateWizard from './pages/CreateWizard';
import DeveloperWeb from './pages/DeveloperWeb';
import { ROOT_PRICING_ROUTE } from '~shared/constants/pricing';

const App = () => {
  const {
    environment: { subdomain },
  } = useContext(StaticContext);

  // From the developer subdomain prepend /developer to the path
  const location = useLocation();
  if (subdomain === 'developer' || subdomain === 'developer.eu') {
    if (!location.pathname.startsWith('/developer')) {
      location.pathname = `/developer${location.pathname}`;
    }
  }

  return (
    <Switch>
      <Route path="/link-blocked/" component={LinkBlocked} />
      <Route path={`${ROOT_PRICING_ROUTE}*`} component={Pricing} />
      <Route path="/apps*" component={AppsDirectory} />
      <Route path="/market-research/solutions/" component={MRXSolutions} />
      <Route path="/createwizard*" component={CreateWizard} />
      <Route path="/developer*" component={DeveloperWeb} />
    </Switch>
  );
};

export default App;
